(() => {
 function init(root) {
  if (!root || root.dataset.ssReady) return;
  root.dataset.ssReady = 'true';
  const life = new AbortController(), observers = [];
  const en = root.lang === 'en';
  root.querySelectorAll('[data-slider]').forEach(slider => {
   const track = slider.querySelector('[data-carousel-track]');
   const controls = Array.from(slider.children).find(el => el.classList.contains('ss-es-sliderControls'));
   if (!track || !controls) return;
   const slides = Array.from(track.children);
   const prev = controls.querySelector('[data-slider-prev]'), next = controls.querySelector('[data-slider-next]');
   const dots = Array.from(controls.querySelectorAll('[data-slider-dot]'));
   const counter = controls.querySelector('.ss-es-sliderCounter');
   const status = slider.querySelector('.ss-es-visuallyHidden');
   let index = 0;
   function update() {
    index = slides.reduce((best, el, i) => Math.abs(el.offsetLeft - track.scrollLeft) < Math.abs(slides[best].offsetLeft - track.scrollLeft) ? i : best, 0);
    prev.disabled = index === 0;
    next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 3;
    dots.forEach((dot, i) => i === index ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current'));
    const visible = Math.max(1, Math.round(track.clientWidth / slides[0].clientWidth));
    if (counter) counter.textContent = (index + 1) + '–' + Math.min(slides.length, index + visible) + (en ? ' of ' : ' de ') + slides.length;
    if (status) status.textContent = (en ? 'Showing ' : 'Mostrando ') + (slider.dataset.slider === 'photos' ? (en ? 'photo ' : 'foto ') : (en ? 'Bible ' : 'Biblia ')) + (index + 1) + (en ? ' of ' : ' de ') + slides.length + '.';
   }
   function go(to) { track.scrollTo({left:slides[Math.max(0, Math.min(slides.length - 1, to))].offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'}); }
   prev.addEventListener('click', () => go(index - 1), {signal:life.signal});
   next.addEventListener('click', () => go(index + 1), {signal:life.signal});
   dots.forEach((dot, i) => dot.addEventListener('click', () => go(i), {signal:life.signal}));
   track.addEventListener('scroll', update, {passive:true,signal:life.signal});
   track.addEventListener('keydown', event => {
    if (event.target !== track) return;
    if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {event.preventDefault();go(index + (event.key === 'ArrowRight' ? 1 : -1));}
    if (event.key === 'Home' || event.key === 'End') {event.preventDefault();go(event.key === 'Home' ? 0 : slides.length - 1);}
   }, {signal:life.signal});
   const observer = new ResizeObserver(update);observer.observe(track);observers.push(observer);
   controls.hidden = false;update();
  });
  const sticky = root.querySelector('.ss-es-stickyShop');
  const hero = root.querySelector('#guia-hero a'), closing = root.querySelector('#guia-cierre');
  if (sticky && hero && closing) {
   function updateSticky() {
    const finish = closing.getBoundingClientRect();
    sticky.hidden = hero.getBoundingClientRect().bottom >= 0 || (finish.top < innerHeight && finish.bottom > 0);
   }
   let queued = false;
   function scheduleSticky() {if (!queued) {queued = true;requestAnimationFrame(() => {queued = false;updateSticky();});}}
   window.addEventListener('scroll', scheduleSticky, {passive:true,signal:life.signal});
   window.addEventListener('resize', scheduleSticky, {passive:true,signal:life.signal});
   const observer = new IntersectionObserver(updateSticky);
   observer.observe(hero);observer.observe(closing);observers.push(observer);updateSticky();
  }
  root.ssSpanishCleanup = () => {life.abort();observers.forEach(observer => observer.disconnect());delete root.dataset.ssReady;};
 }
 function scan(scope) {if (scope.matches?.('[data-ss-spanish-guide]'))init(scope);scope.querySelectorAll?.('[data-ss-spanish-guide]').forEach(init);}
 scan(document);
 document.addEventListener('shopify:section:load', event => scan(event.target));
 document.addEventListener('shopify:section:unload', event => event.target.querySelector('[data-ss-spanish-guide]')?.ssSpanishCleanup?.());
})();
